var map = {
	"./autoplay/lg-autoplay.es5.js": [
		8509,
		8
	],
	"./comment/lg-comment.es5.js": [
		8080,
		238
	],
	"./fullscreen/lg-fullscreen.es5.js": [
		2508,
		846
	],
	"./hash/lg-hash.es5.js": [
		1185,
		649
	],
	"./mediumZoom/lg-medium-zoom.es5.js": [
		7180,
		400
	],
	"./pager/lg-pager.es5.js": [
		6220,
		359
	],
	"./relativeCaption/lg-relative-caption.es5.js": [
		823,
		515
	],
	"./rotate/lg-rotate.es5.js": [
		4671,
		893
	],
	"./share/lg-share.es5.js": [
		627,
		642
	],
	"./thumbnail/lg-thumbnail.es5.js": [
		1997,
		725
	],
	"./video/lg-video.es5.js": [
		2523,
		568
	],
	"./zoom/lg-zoom.es5.js": [
		2869,
		719
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8508;
module.exports = webpackAsyncContext;